import { login, logout, getInfo, checkToken } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth';
// import router from '@/router'
// import router, { resetRouter } from '@/router'
const state = {
  token: getToken(),
  name: '',
  avatar: '',
  mobel:'',
  sex:'',
  pwdCount:0,
  username:''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_MOBILE:(state, mobile) =>{
    state.mobile = mobile
  },
  SET_SEX:(state, sex)=>{
    state.sex = sex
  },
  SET_USERNAME:(state, username)=>{
    state.username = username
  },
  REMOVE_TOKEN: (state, token) => {
    state.token = ''
  },
  increment:state=>state.pwdCount++
}

const actions = {
  increment:({commit})=>commit('increment'),
  login({ commit }, userInfo) {
    const { username, password, validCode, deviceId, grant_type } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password,
        validCode: validCode,
        deviceId: deviceId,
        grant_type: 'password_code_study'
        //grant_type: 'password'
      }).then(response => {
        const data = response
        commit('SET_TOKEN', data.datas.access_token)
        setToken(data.datas.access_token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit,state }) {
    console.log(state,"state==================")
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { datas } = response
        const { nickname, headImgUrl,id,username} = datas
        commit('SET_NAME', nickname)
        commit('SET_USERNAME', username)
        commit('SET_AVATAR', headImgUrl)
        window.localStorage.setItem('username',state.username);
        window.localStorage.setItem('nickname',state.name);
        window.localStorage.setItem('headImgUrl',state.avatar || '');
        window.localStorage.setItem('id',id);
        resolve(datas)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  // logout({ commit, state, dispatch }) {
  //   return new Promise((resolve, reject) => {
  //     logout(state.token).then(() => {
  //       commit('SET_TOKEN', '')
  //       // commit('SET_ROLES', [])
  //       removeToken()
  //       // resetRouter()
  //       // reset visited views and cached views
  //       // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
  //       // dispatch('tagsView/delAllViews', null, { root: true })
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  logout({ commit, state, dispatch }) {
    const token = state.token
    return new Promise((resolve, reject) => {
      checkToken(token).then(response => {
        commit('SET_TOKEN', ' ')
        commit('SET_NAME', ' ')
        removeToken()
        if (response.active) {
          logout(token)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },


  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },

  // 切换用户
  // dynamically modify permissions
  // async changeRoles({ commit, dispatch }, role) {
  //   const token = role + '-token'

  //   commit('SET_TOKEN', token)
  //   setToken(token)

  //   const { roles } = await dispatch('getInfo')

  //   // resetRouter()

  //   // generate accessible routes map based on roles
  //   const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
  //   // dynamically add accessible routes
  //   router.addRoutes(accessRoutes)

  //   // reset visited views and cached views
  //   dispatch('tagsView/delAllViews', null, { root: true })
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js